<template>
  <div class="point-festival root">
    <div v-if="campaignReady" class="banner">
      <img :src="campaign.banner" :alt="info.title" />
    </div>

    <div v-if="campaignReady" class="info">
      <div class="info-card">
        <div class="info-title">{{ info.title }}</div>
        <div class="info-sub">{{ info.subtitle }}</div>
        <div class="info-boxes">
          <div class="info-box">
            <div class="box-label">ระยะเวลาร่วมสนุก</div>
            <div class="box-value">{{ info.period }}</div>
            <div class="box-note">{{ info.periodNote }}</div>
          </div>
          <div class="info-box">
            <div class="box-label">{{ info.rateLabel }}</div>
            <div class="box-value">{{ info.rate }}</div>
          </div>
        </div>
        <div v-if="info.eligible" class="info-eligible">{{ info.eligible }}</div>
      </div>
      <div class="info-dates">
        <div class="date-col">
          <div class="date-label">{{ info.drawLabel }}</div>
          <div class="date-box">{{ info.drawAt[0] }}<br />{{ info.drawAt[1] }}</div>
        </div>
        <div class="date-col">
          <div class="date-label">{{ info.announceLabel }}</div>
          <div class="date-box">{{ info.announceAt[0] }}<br />{{ info.announceAt[1] }}</div>
        </div>
      </div>
    </div>

    <div class="container rules">
      <div class="rules-title">เงื่อนไขกิจกรรม</div>
      <div v-if="state == 'loading'" class="text-center text-muted">กำลังโหลด...</div>
      <div v-else-if="state == 'error'" class="text-center text-muted">
        ไม่พบข้อมูลกิจกรรม กรุณาลองใหม่ภายหลัง
      </div>
      <div v-else class="rules-content" v-html="luckyDraw.description"></div>
    </div>

    <div class="action_segment">
      <button
        class="btn-festival btn-red"
        :disabled="!canJoin"
        @click="goJoin"
        data-tag="point_festival_start"
      >
        เริ่มลุ้นรางวัล
      </button>
      <!-- shown from the announcement date -->
      <button
        v-if="announced"
        class="btn-festival btn-dark"
        @click="goWinners"
        data-tag="point_festival_winners"
      >
        รายชื่อผู้โชคดี
      </button>
    </div>
    <div v-if="!announced" class="announce-note">
      ประกาศรายชื่อผู้โชคดี {{ announceText }}
    </div>
  </div>
</template>

<script>
import {
  currentCampaign,
  isSaleTypeKnown,
  loadCampaign,
  fetchPointFestival,
  trackFestival,
  getAnnounceDate,
  isAnnounced,
  formatThaiShortDate,
} from "@/helper/pointFestival";

export default {
  name: "pointFestival",
  data() {
    return {
      state: "loading",
      luckyDraw: null,
    };
  },
  computed: {
    campaign() {
      return currentCampaign();
    },
    info() {
      return this.campaign.info;
    },
    // a deep link may arrive before the profile, so wait rather than flash the wrong campaign
    campaignReady() {
      return isSaleTypeKnown() || this.state != "loading";
    },
    canJoin() {
      return this.state == "ok" && this.luckyDraw.isActive === true;
    },
    announced() {
      return isAnnounced(this.luckyDraw, this.campaign);
    },
    announceText() {
      return formatThaiShortDate(getAnnounceDate(this.luckyDraw, this.campaign));
    },
  },
  methods: {
    async init() {
      try {
        this.luckyDraw = await fetchPointFestival(this.$JWT, await loadCampaign(this.$JWT));
        this.state = this.luckyDraw ? "ok" : "error";
      } catch (error) {
        console.log(error);
        this.state = "error";
      }
    },
    goJoin() {
      trackFestival("click_start");
      this.$router.push({ name: "point-festival-join" });
    },
    goWinners() {
      trackFestival("click_winners");
      this.$router.push({ name: "point-festival-winners" });
    },
  },
  beforeMount() {
    window.scrollTo(0, 0);
  },
  mounted() {
    this.init();
    window.loading(false);
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/pointFestival.scss";

.root {
  font-size: 16px;
  background: #fff;
  min-height: 100vh;
  padding-bottom: 130px;
}

.info {
  background: #c8102e;
  padding: 16px;
  text-align: center;
  .info-card {
    background: #fff;
    border: 3px solid #f5c76b;
    border-radius: 16px;
    padding: 14px 12px;
  }
  .info-title {
    font-size: 26px;
    font-weight: 700;
    line-height: 1.1;
  }
  .info-sub {
    font-size: 16px;
    font-weight: 700;
  }
  .info-boxes {
    display: flex;
    gap: 10px;
    margin: 12px 0 8px;
  }
  .info-box {
    flex: 1;
    background: #f9c97c;
    border-radius: 12px;
    padding: 8px 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .box-label {
    font-size: 14px;
    font-weight: 700;
  }
  .box-value {
    font-size: 19px;
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;
  }
  .box-note {
    font-size: 12px;
  }
  .info-eligible {
    font-size: 12px;
  }
  .info-dates {
    display: flex;
    gap: 10px;
    margin-top: 12px;
  }
  .date-col {
    flex: 1;
    display: flex;
    flex-direction: column;
    // a label that wraps to two lines still lines its box up with the other column
    justify-content: flex-end;
  }
  .date-label {
    white-space: pre-line;
    color: #fff;
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 4px;
  }
  .date-box {
    background: #f9c97c;
    border: 2px solid #fff;
    border-radius: 12px;
    padding: 6px 4px;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.4;
  }
}

.rules {
  padding-top: 16px;
  .rules-title {
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 8px;
  }
  .rules-content {
    font-size: 14px;
    line-height: 1.6;
  }
}

.action_segment {
  display: flex;
  gap: 12px;
  padding: 12px 15px;
  width: 100%;
  max-width: 450px;
  background: #fff;
  position: fixed;
  bottom: 24px;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.06);
}

.announce-note {
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 450px;
  height: 24px;
  background: #fff;
  font-size: 12px;
  color: #888;
  text-align: center;
}
</style>
